import { FormEvent, useState } from 'react';
import { Search, X } from 'lucide-react';

/**
 * Champ de recherche avec bouton — remplace antd Input.Search.
 */
const SearchInput = (props: {
    onSearch: (value: string) => void;
    placeholder?: string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}) => {
    const [value, setValue] = useState('');

    const submit = (e?: FormEvent) => {
        e?.preventDefault();
        props.onSearch(value);
    };

    const sizeClass = { sm: 'py-1.5 text-xs', md: 'py-2 text-sm', lg: 'py-2.5 text-base' }[props.size || 'md'];

    return (
        <form onSubmit={submit} className={`relative flex items-center ${props.className || ''}`}>
            <Search size={16} className="absolute left-3 text-[var(--eb-text-muted)] pointer-events-none" />
            <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={props.placeholder || 'Rechercher…'}
                className={`w-full pl-9 pr-16 rounded-lg border border-[var(--eb-border)] bg-[var(--eb-surface)] text-[var(--eb-text)] placeholder:text-[var(--eb-text-muted)]/60 focus:outline-none focus:ring-2 focus:ring-[var(--eb-primary)]/40 focus:border-[var(--eb-primary)] ${sizeClass}`}
            />
            {value && (
                <button type="button" onClick={() => { setValue(''); props.onSearch(''); }} className="absolute right-12 p-1 text-[var(--eb-text-muted)] hover:text-[var(--eb-text)]">
                    <X size={14} />
                </button>
            )}
            <button
                type="submit"
                className="absolute right-1 px-3 py-1 text-xs font-semibold rounded-md bg-[var(--eb-primary)] text-white hover:opacity-90"
            >
                OK
            </button>
        </form>
    );
};

export default SearchInput;
